
// const API_PATHS = {
//   // login: 'http://localhost:3000/api/auth',
//   login: `https://lotus-api-n5eq.onrender.com/api/auth`,
//   comment : 'http://localhost:3000/api/post/comments',
//   // api : 'http://localhost:3000/api',
//   sse : 'http://localhost:3000/sse',
// };
const API_PATHS = {
  login: `https://lotus-api-n5eq.onrender.com/api/auth`,
  comment : 'https://lotus-api-n5eq.onrender.com/api/post/comments',
  api : 'https://lotus-api-n5eq.onrender.com/api',
  sse : 'https://lotus-api-n5eq.onrender.com/api/sse',
};
export default API_PATHS;